import React from 'react';
import newLogo from '../Logo/logo_long.svg';

const iconStyles = {
  fill: 'red'
};

// eslint-disable-next-line react/prop-types,react/display-name
export default ({ w, h }: {w: string, h: string}) => (
  <img src={newLogo} style={iconStyles} alt="Smartlane logo" width={w} height={h} />
);
